import { reactive } from 'vue'

const state = reactive({
    active: false,
})

// -----------------------------------
// Private Methods
// -----------------------------------
let close // will hold our promise resolve function
const dialogPromise = () => new Promise((resolve) => (close = resolve))
const open = () => {
    state.active = true
    return dialogPromise()
}
const reset = () => {
    state.active = false
}

// -----------------------------------
// Public interface
// -----------------------------------

const scheduleModalService = {
    get state() {
        return state
    },
    show() {
        return open()
    },
    cancel() {
        close(false)
        reset()
    },
}

export default scheduleModalService